import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

let msalObj: PublicClientApplication | null = null;
let initializationPromise: Promise<PublicClientApplication> | null = null;

const createMsalInstance = async (): Promise<PublicClientApplication> => {
  if (msalObj) {
    return msalObj;
  }

  if (initializationPromise) {
    return initializationPromise;
  }

  initializationPromise = (async () => {
    try {
      // Check if crypto is available before initializing MSAL
      if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle) {
        throw new Error(
          'Crypto API not available. Microsoft login is not supported in this environment.'
        );
      }

      const instance = new PublicClientApplication(msalConfig);
      await instance.initialize();
      msalObj = instance;
      return instance;
    } catch (error) {
      console.warn('Failed to initialize MSAL:', error);
      initializationPromise = null;
      throw error;
    }
  })();

  return initializationPromise;
};

export default {
  getInstance: createMsalInstance,
  // Legacy support - this will be null initially and require calling getInstance()
  ...({} as PublicClientApplication),
  resetInstance: () => {
    msalObj = null;
    initializationPromise = null;
  },
};
